import { render, staticRenderFns } from "./InvoicesAndCreditNotesSales.vue?vue&type=template&id=abb8c4ea&"
import script from "./InvoicesAndCreditNotesSales.vue?vue&type=script&lang=js&"
export * from "./InvoicesAndCreditNotesSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports